import {useParams} from 'react-router-dom';
import styled from "styled-components";
import {useEffect, useState} from "react";
import {User, Search as LucideSearch} from "lucide-react";
import {WhiteMain} from '../../components/main';
import TopBar from '../../components/top_bar';
import {useBaseCommunity} from '../../store';
import TopHeadroom from "../../components/top_headroom";
import {useBottomBar} from "../../app_context";
import NavLink from "../../components/nav_link";
import {useCommunitySearch} from "../../api/communities";
import useFeedback from "../../utils/use_feedback";
import {useQuery} from "../../utils/router";
import {placeholderImage} from "../../components/community_logo";
import {themecolors} from "../../utils/themecolors";

const SearchOption = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
  padding: 16px 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 15px;
  display: flex;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};

  svg {
    margin-right: 12px;
  }
  
  &:active {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_4 : 'rgba(0,0,0,.06)'};
  }
`;

const CommunityIcon = styled.div`
  margin-right: 12px;
  width: 28px;
  height: 28px;

  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
`;

const Browse = ({}) => {
    const baseCommunity = useBaseCommunity();
    const {community: searchCommunity} = useQuery();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    useBottomBar();

    const [query, setQuery] = useState('');
    const feedback = useFeedback();
    const communities = useCommunitySearch(feedback.channel, query);

    const [exactCommunity, setExactCommunity] = useState(false);

    useEffect(() => {
        if (query && communities) {
            communities.forEach((community) => {
                if (community.name.toLowerCase() === query.toLowerCase()) {
                    setExactCommunity(community);
                }
            });
        }
    }, [communities]);
    
    return (
        <>
            <TopBar back query={query} setQuery={setQuery} focus search isSearch community={community} settings border />
            <WhiteMain style={{paddingBottom: 60}}>
                {query && (<>
                    <NavLink href={`/search?query=${query}${searchCommunity ? `&community=${searchCommunity}` : ''}`}>
                        <SearchOption> <LucideSearch size={24} /> View results for '{query}'</SearchOption>
                    </NavLink>
                    <NavLink href={`/u/${query}`} react_route>
                        <SearchOption>
                            <User size={24} /> u/{query}
                        </SearchOption>
                    </NavLink>
                    {communities?.map((community) => (
                        <NavLink key={community.name} href={`/c/${community.name}`} react_route>
                            <SearchOption>
                                <CommunityIcon>
                                    <img
                                        src={community.icon ? `https://img.scored.co/community/${community.name.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage}/>
                                </CommunityIcon>
                                {community.name}</SearchOption>
                        </NavLink>
                    ))}
                </>)}
            </WhiteMain>
        </>
    );
};

export default Browse;
